import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HomeThick = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="Icons">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.81429 0.820881C7.48625 0.195123 8.52758 0.195123 9.19954 0.820881L13.7871 5.09299C13.8199 5.12352 13.8513 5.15518 13.8815 5.18788L15.2235 6.41796C15.5288 6.69785 15.5495 7.17227 15.2696 7.47762C15.0282 7.741 14.642 7.79256 14.3445 7.62214V13.3186C14.3445 14.2851 13.561 15.0686 12.5945 15.0686H3.41938C2.45288 15.0686 1.66938 14.2851 1.66938 13.3186V7.70337C1.36913 7.97487 0.905423 7.95932 0.624167 7.66474C0.33813 7.36514 0.349119 6.8904 0.648712 6.60436L2.13269 5.18753C2.16272 5.15495 2.19409 5.12341 2.22675 5.09299L2.42775 4.90582L2.72525 4.62178C2.74926 4.59885 2.7744 4.57784 2.80047 4.55872L6.81429 0.820881ZM11.8671 5.35473C11.8968 5.39607 11.9312 5.435 11.9702 5.47076L12.8 6.23143C12.8287 6.27288 12.8445 6.32243 12.8445 6.37368V13.3186C12.8445 13.4567 12.7325 13.5686 12.5945 13.5686H3.41938C3.28131 13.5686 3.16938 13.4567 3.16938 13.3186V6.37368C3.16938 6.31951 3.18695 6.26725 3.21881 6.22444L3.45683 5.99718L7.83654 1.91861C7.93254 1.82921 8.0813 1.82921 8.17729 1.91861L11.8671 5.35473Z"
          fill={color}
        />
      </g>
    </svg>
  )
})

export default HomeThick
